import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    paymentInfoContainer: {
        height: '6.7vh',
        overflowY: 'scroll',
    },
    paymentText: {
        color: theme?.checkDetails.paymentLabelColor,
    },
    amountLabel: {
        color: theme?.checkDetails.amountLabel,
    },
    amountValue: {
        color: theme?.checkDetails.amountValue,
        width: '5vw',
        position: 'absolute',
        right: 0,
    },

}));

export default useStyles;